export default __webpack_public_path__ + "static/media/buildbutton.eadb6bb1.png";